import C from './component'
import ThumbnailSliderOnQueue from './on_queue'
export { ThumbnailSliderOnQueue }
export default C